import { render, staticRenderFns } from "./link-with-icon-minimal.vue?vue&type=template&id=45e663c6&scoped=true&"
import script from "./link-with-icon-minimal.vue?vue&type=script&lang=js&"
export * from "./link-with-icon-minimal.vue?vue&type=script&lang=js&"
import style0 from "./link-with-icon-minimal.vue?vue&type=style&index=0&id=45e663c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e663c6",
  null
  
)

export default component.exports